import request from '@/utils/request'

export function getInitData(lang) {
  return request({
    url: '/info/app-init?lang=' + lang,
    method: 'get'
  })
}
